module.exports = __webpack_public_path__ + "img/company_icon1.2d5e63b1.png";